import React from 'react'
import { useServerReadiness } from '~/core/hooks/useServerReadiness'
import { FullPageError } from './Errors'
import LoadingMessage from './LoadingMessage'
import cs from './server_readiness_screen.scss'

interface ServerReadinessScreenProps {
  serverUrl: string
  children: React.ReactNode
}

export default function ServerReadinessScreen({
  serverUrl,
  children,
}: ServerReadinessScreenProps) {
  const { isServerReady, isChecking, error } = useServerReadiness(serverUrl)

  if (error) {
    return <FullPageError error={new Error(error)} customFriendlyMessage={error} />
  }

  if (isChecking || !isServerReady) {
    return (
      <div className={cs.serverReadinessScreen}>
        <div className={cs.content}>
          <LoadingMessage
            className={cs.loadingMessage}
            label='Starting server, please wait...'
            type='accent'
            variant='large'
          />
          <p className={cs.subtext}>
            The application is initializing. This may take a few moments.
          </p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
